export default {
  title: {
    en: 'Need to change how often you get your scents?',
  },
  text: {
    en: 'Adjust your subscription frequency to once every {period}',
  },
  singlePeriod: {
    en: '{period, plural, one {# month}, other {# months}}',
  },
  doublePeriod: {
    en: '{period1} or {period2} months',
  },
  confirmButton: {
    en: 'Confirm',
  },
}
